'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _differenceBy = require('lodash/differenceBy');

var _differenceBy2 = _interopRequireDefault(_differenceBy);

var _flatten = require('lodash/flatten');

var _flatten2 = _interopRequireDefault(_flatten);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _identity = require('lodash/identity');

var _identity2 = _interopRequireDefault(_identity);

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _isArrayLike = require('lodash/isArrayLike');

var _isArrayLike2 = _interopRequireDefault(_isArrayLike);

var _mobx = require('mobx');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (collection) {
  var factoryOrName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _identity2.default;
  var optName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Collection';


  var itemFactory = typeof factoryOrName === 'function' ? factoryOrName : _identity2.default;
  var name = typeof factoryOrName === 'string' ? factoryOrName : optName;

  function manufactureItems(items) {
    return items.reduce(function (all, item) {
      var manufactured = itemFactory(item);

      // Include item only if factory returns truthy
      if (!!manufactured) all.push(manufactured);

      return all;
    }, []);
  }

  function getActionName(description) {
    return name + ' - ' + description;
  }

  // Checks prop on item, or if prop is undefined item directly, against checkValue.
  function equalCheck(item, prop, checkValue) {
    var checkAgainst = (typeof item === 'undefined' ? 'undefined' : _typeof(item)) !== 'object' ? item : (0, _get2.default)(item, prop, item);
    return checkAgainst === checkValue;
  }

  // Used in array difference checks
  var differenceCheck = function differenceCheck(key) {
    return function (value) {
      return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object' ? value : (0, _get2.default)(value, key, value);
    };
  };

  // Replaces current items with new items
  var setItems = (0, _mobx.action)(getActionName('Set items'), function () {
    var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var arrItems = (0, _flatten2.default)([items]);
    collection.replace(arrItems.map(itemFactory));
  });

  // Gets an item from the collection (not an action per se)
  var getItem = function getItem(identifier) {
    var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';

    var id = (0, _get2.default)(identifier, key, identifier);
    var item = collection.find(function (item) {
      return equalCheck(item, key, identifier);
    });

    return typeof item !== 'undefined' ? item : null;
  };

  var getByIndex = function getByIndex(index) {
    return collection[index];
  };

  var getIndex = function getIndex(item) {
    var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';

    var id = (0, _get2.default)(item, key, item);
    return collection.findIndex(function (el) {
      return equalCheck(el, key, id);
    });
  };

  // Adds items to the collection. Returns unprocessed array of added items.
  var addItems = (0, _mobx.action)(getActionName('Add items'), function () {
    var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var unique = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';
    var processAll = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _identity2.default;

    var itemsArray = (0, _flatten2.default)([items]); // Put in one-element array if only passed single item
    if (itemsArray.length === 0) return []; // Bail early if no items

    // Get items not already in the collection by unique key (assumes array items are objects)
    var itemsToAdd = unique === false ? itemsArray : (0, _differenceBy2.default)(itemsArray, collection.slice(), differenceCheck(unique));

    // If all "new" items already exist, bail.
    if (itemsToAdd.length === 0) return [];

    // Run items through the factory
    var preparedItems = manufactureItems(itemsToAdd);

    // Concatenate the new items, processed through itemFactory, to the existing collection.
    var allItems = collection.concat(preparedItems);

    // Run items through an optional processor (a good opporunity to apply ordering)
    // and replace the current collection with the new one.
    collection.replace(processAll(allItems));

    return preparedItems;
  });

  // Adds a single item to the collection, optionally checking for uniqueness.
  // Returns the (unprocessed) added item.
  var addItem = (0, _mobx.action)(getActionName('Add item'), function (item) {
    var unique = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';
    var replace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var first = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    if (typeof item === 'undefined') return; // Do not check for falsiness as that is a valid value.

    // Defer to addItems if array
    if ((0, _isArrayLike2.default)(item)) {
      return addItems(item, unique);
    }

    // Uniqueness check
    var existingIdx = unique === false ? -1 : getIndex(item, unique);
    if (existingIdx > -1 && !replace) return collection[existingIdx]; // Bail if it exists in the collection

    var preparedItem = itemFactory(item); // Construct item

    // Get arguments for splice. We can't feed it existingIdx
    // blindly, as -1 would mean one from the end.
    var spliceIndex = existingIdx > -1 ? existingIdx : 0;
    var spliceRemove = existingIdx > -1 ? 1 : 0;

    if (existingIdx > -1 && replace) collection.splice(spliceIndex, spliceRemove, preparedItem);else {
      first ? collection.unshift(preparedItem) : collection.push(preparedItem);
    }

    return preparedItem;
  });

  // Updates an item in the collection with new data.
  // Returns the added item.
  var updateItem = (0, _mobx.action)(getActionName('Update item'), function () {
    var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var idProp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';

    if (!item) return false;
    var existingIdx = getIndex(item, idProp);

    if (existingIdx === -1) {
      return item; // Bail if it doesn't exist
    }

    if ((0, _mobx.isObservable)(collection[existingIdx])) {
      // Extend the new data onto the existing item.
      return (0, _mobx.extendObservable)(collection[existingIdx], item);
    } else {
      // If this code runs, the item to add is probably a string or similar simple type.
      // Can't really use extend, so just replace it in the collection.
      var itemToAdd = itemFactory(item);
      collection.splice(existingIdx, 1, itemToAdd);

      return itemToAdd;
    }
  });

  // Updates (if exists) or adds an item to the collection.
  // Returns the unprocessed added or updated item.
  var updateOrAdd = (0, _mobx.action)(getActionName('Update or add'), function (item) {
    var idProp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';
    var first = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var existingIdx = getIndex(item, idProp);

    if (existingIdx > -1) return updateItem(item, idProp);else return addItem(item, false, false, first);
  });

  // Removes an item from the collection
  var removeItem = (0, _mobx.action)(getActionName('Remove item'), function () {
    var itemOrIdOrIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var idProp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';

    if (itemOrIdOrIndex === false) return false; // Bail early if falsy

    var type = typeof itemOrIdOrIndex === 'undefined' ? 'undefined' : _typeof(itemOrIdOrIndex);
    var removeIdx = -1; // Start off carefully...

    switch (type) {
      case 'number':
        // Assume index if type is number
        removeIdx = itemOrIdOrIndex;
        break;
      case 'string':
        // Assume id if type is string
        removeIdx = collection.findIndex(function (el) {
          return equalCheck(el, prop, itemOrIdOrIndex);
        });
        break;
      default:
        // Assume object otherwise, and set idx to -1 if idProp is not a thing
        removeIdx = typeof itemOrIdOrIndex[idProp] !== 'undefined' ? getIndex(itemOrIdOrIndex, idProp) : collection.indexOf(itemOrIdOrIndex);
    }

    // Only do anything if idx is sane. Return the removed item.
    if (removeIdx > -1) return collection.splice(removeIdx, 1)[0];

    // We've accomplished nothing.
    return false;
  });

  var clear = (0, _mobx.action)(getActionName('Clear'), function () {
    var filterFunction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (!filterFunction) return collection.clear();

    collection.forEach(function (item, idx) {
      if (filterFunction(item) === true) collection.splice(idx, 1);
    });

    return collection;
  });

  return {
    $collection: {
      name: name, factory: itemFactory
    },
    setItems: setItems,
    getItem: getItem,
    getIndex: getIndex,
    getByIndex: getByIndex,
    removeItem: removeItem,
    addItem: addItem,
    addItems: addItems,
    updateItem: updateItem,
    updateOrAdd: updateOrAdd,
    clear: clear
  };
};